import axios from 'axios'
import { constructQueryParams, toTitleCase, trimAll } from './Validators'
import { NotificationManager } from "react-notifications"
import apiURL, { domain } from "../../../store/actions/apiURL"

const keys = {
    LOCAL_API_KEY: 'dtoken_hEDzcyiWMr2a4ZMkv3nfc7qO1JQxqKYozwO4baBJybNuqb9kc5bi0o1eyhADhPZyhn4J_DUwC8qK3N332AXx5h8ucb2vIxzKc-kkt-H9u0KN1VTsVLzuGSdQhBbFuQoImNi61tN6m5XR56rkuMJkNKSVHGGAEy0UWwnjS3ZhPpMTYWkfGW3dAFgxEYICw0lPhdNhGi-avSsS-CwysHDO1k745oaySDWP',
    LIVE_API_KEY: 'dtoken_hEDzcyiWMr2a4ZMkv3nfc7qO1JQxqKYozwO4baBJybNuqb9kc5bi0o1eyhADhPZyoHfyuboeWzpkNpMylMvvE-UmYaUrTFKHJ1CEFsW5CgiY2LrW03qbldHnquS4wmQ0pJUcYYATLRRbCeNLdmE-kxNhaR8Zbd0AWDERggLDSU9Cv0AMHXFbtY8Hl1zWqmd0TvjmhrJINY8',
    REVIEW_API_KEY: 'dtoken_hEDzcyiWMr2a4ZMkv3nfc7qO1JQxqKYozwO4baBJybNuqb9kc5bi0o1eyhADhPZy8Pbc27EzZFjJrr-a1MgyitNvGkdx8st4F6JU21MSO361jN0psTNtvHhuicZMg-998ZuJOgY_oEyxk3Aw4_ZrM48_Cu-UzYqGPgjbV9ic7KwNgCG6k3ikbDVKBO82jZToltaIBUnEtf0yiCLtHZEylg',
    STAGE_API_KEY: 'dtoken_hEDzcyiWMr2a4ZMkv3nfc7qO1JQxqKYozwO4baBJybNuqb9kc5bi0o1eyhADhPZyqh-3OOe5ZYHYoLlW4MAXQ3RdEO8frBHR0JAXp49bF6OcAcOwLh9HdJC7lXMr-kmwuNDmScS5mnoKJwAUGooTCfT63avurJC5f-KAIuLdcVYSUV8CELY7Uq9g25hTiiQpots0NVgOyDovMetEJarCYg',
}

const API_KEY = keys[`${domain.toUpperCase()}_API_KEY`]

const getUKAddress = async (postCode) => {
    let response

    await axios({
        method: 'GET',
        url: `https://api.getaddress.io/find/${postCode}${constructQueryParams({ ['api-key']: API_KEY, expand: true })}`
    })
        .then(r => response = r)
        .catch(r => response = r.response)

    const { status } = response

    switch (String(status)) {
        case '400':
            // NotificationManager.error("Post Code is Invalid, please check your input!")
            return
        case '403':
        case '401':
            NotificationManager.error("Error Getting Post Code")
            return
    }

    const { addresses, longitude, latitude } = { ...response?.data }

    const addressList = addresses?.map(item => {
        const address = {
            postCode,
            houseNumber: item['building_name'] || item['building_number'],
            subBuilding: item['sub_building_name'] || item['sub_building_number'],
            street: item.thoroughfare,
            city: item['town_or_city'],
            locality: item.locality,
            county: item.county,
            country: item.country,
            district: item.district,
            longitude,
            latitude
        }

        const fullAddress = [address.subBuilding, address.houseNumber, address.street, address.locality, address.city, address.county, address.country].reduce((prev, curr) => {
            if (!prev && curr) prev = curr
            else if (prev && curr) prev = prev.concat(', ', curr)
            return prev
        }, '')

        return {
            ...address,
            fullAddress,
        }
    })
    return addressList
}
const getMTAddress = async (postCode) => {
    let response

    await axios({
        method: 'GET',
        url: `${apiURL}/settings/address${constructQueryParams({ postCode })}`,
        withCredentials: true,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    })
        .then(r => response = r)
        .catch(r => response = r.response)

    const { status } = response

    switch (String(status)) {
        case '400':
            // NotificationManager.error("Post Code is Invalid, please check your input!")
            return
        case '403':
        case '401':
            NotificationManager.error("Error Getting Post Code")
            return
    }

    const { addresses } = { ...response?.data }

    const addressList = addresses?.map(item => {
        const houseNumber = [item.houseNo, item.houseName, item.houseAlpha, item.flatNo].reduce((prev, curr) => {
            if (!prev && curr) prev = curr
            else if (prev && curr) prev = prev.concat(', ', curr)
            return prev
        }, '')

        const address = {
            postCode: trimAll(item.postCode),
            houseNumber: toTitleCase(houseNumber).replaceAll("Nru.,", ''),
            street: toTitleCase(item.street),
            city: toTitleCase(item.locality),
            country: toTitleCase(item.country),
        }

        const fullAddress = [address.houseNumber, address.street, address.city, address.country].reduce((prev, curr) => {
            if (!prev && curr) prev = curr
            else if (prev && curr) prev = prev.concat(', ', curr)
            return prev
        }, '')

        return {
            ...address,
            fullAddress,
        }
    })
    return addressList
}
const getAddressFromPostCode = async ({ postCode, jurisdiction }) => {
    if (!postCode) return
    if (typeof postCode !== 'string') return
    if (postCode.length <= 2) return

    let addressList = []

    switch (jurisdiction) {
        case 'MT':
            addressList = await getMTAddress(postCode)
            break
        case 'UK':
            addressList = await getUKAddress(postCode)
            break
    }

    return addressList
}

export { getAddressFromPostCode }